import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/MyOrders/MyOrders.js
const MyOrders = createSectionForm({
  icon: "shopping-bag-line",
  title: "My Orders",
  fields: [{ name: "title", label: "Heading", placeholder: "My Orders" }],
});

export default MyOrders;
